const TRACKS = [
  'https://assets.wesknight.dev/music/at-1.mp3',
  'https://assets.wesknight.dev/music/at-2.mp3',
  'https://assets.wesknight.dev/music/at-3.mp3',
  'https://assets.wesknight.dev/music/at-4.mp3',
  'https://assets.wesknight.dev/music/at-5.mp3',
  'https://assets.wesknight.dev/music/at-6.mp3',
];

function shuffle<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export class AudioManager {
  private playlist: string[] = [];
  private currentIndex: number = 0;
  private audio: HTMLAudioElement = new Audio();
  private started: boolean = false;

  constructor() {
    this.playlist = shuffle(TRACKS);
    this.audio.volume = 0.08;
    this.audio.addEventListener('ended', () => this.playNext());
  }

  public start() {
    if (this.started) return;
    this.started = true;
    this.playCurrent();
  }

  public toggleMute(): boolean {
    this.audio.muted = !this.audio.muted;
    return this.audio.muted;
  }

  public isMuted(): boolean {
    return this.audio.muted;
  }

  public skipToNext() {
    this.advanceIndex();
    this.playCurrent();
  }

  private playNext() {
    this.advanceIndex();
    this.playCurrent();
  }

  private advanceIndex() {
    this.currentIndex = (this.currentIndex + 1) % this.playlist.length;
  }

  private playCurrent() {
    this.audio.src = this.playlist[this.currentIndex];
    this.audio.play().catch(() => { });
  }
}
